import { AvailabilityState } from './types';

export const state = (): AvailabilityState => initialState();

export const initialState = (): AvailabilityState => ({
  availabilities: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['Name'],
    },
  },
});
